import { I18n } from 'vendor/i18n-js/index.js.erb'
import Rails from '@rails/ujs'
import * as Turbo from "@hotwired/turbo"
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

const E = window.E = window.E || { }

// Enable Rails UJS; See: http://guides.rubyonrails.org/working_with_javascript_in_rails.html
E.Rails = Rails
E.Rails.start()

E.Turbo = Turbo

E.Turbo.StreamActions.redirect = function () {
  E.Turbo.visit(this.target)
}

// Stimulus:
E.application = Application.start()
E.context = require.context("../controllers", true, /(realtime_widget.+\.js|widget_popover_controller\.js|embedded_controller\.js|invite.+\.js|autogrow_controller\.js)$/)
E.application.load(definitionsFromContext(E.context))

// Temporary:
E.widget = function() {
  return E.application.getControllerForElementAndIdentifier(
    document.getElementById('reservation_form'),
    'realtime-widget'
  )
}
